import React from 'react'
import CountTree from '../app/dashboard/CountTree'

const OurAim = () => {
    return (
        <>

            <section className="section-sp1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <CountTree type={"Login"} />
                            <h1 className='text-center title-head'>About</h1>
                            <p style={{ textAlign: "justify" }}>Mission aim is to facilitate and supervise the planting of 11000 trees all over in and around the KOTA city. Mission vriksha is an campaign by Rotary club kota in association with Reliable Institute Kota. To promote the  planting of trees and reduce the eco footprints of the city to tackle the adverse effect of climate change. To promote the planting of trees as a lifestyle. To raise awareness on the dangers of deforestation. To mobilize resources for the expansion of woodland.</p>



                        </div>

                    </div>
                </div>
            </section>
            <section className="">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className='text-center title-head'>Prizes &amp; Awards</h1>
                            <div className="row justify-content-center">
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>1<sup>st</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/iphone13.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }
                                        } > IPhone 13</h4>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>2<sup>nd</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/ipad.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }}>IPad Air</h4>

                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>3<sup>rd</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/apple-watch.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }}>Apple Watch</h4>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>4<sup>th</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/apple-earpods.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }}>Apple Ear Pods</h4>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>5<sup>th</sup> - 10<sup>th</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/boat-watch.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }}>Boat Smart Watches</h4>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h5>11<sup>th</sup> - 20<sup>th</sup> Prize</h5>
                                        <img src="https://reliablekota.com/mission-vriksh/boat-earpods.png" alt="" style={{
                                            height: "120px", width: "120px"
                                        }} />
                                        <h4 style={{ color: "#b11116" }}>Boat Ear Pods</h4>
                                    </div>
                                </div>
                            </div>
                            <p className='pt-5 text-center'><strong>Note: </strong> Every successful contestant will be given a certificate after successful submission of required pics for competition.</p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default OurAim